<template>
  <div class="mt-n2">
    <template v-if="showETickets">
      <div class="mb-3">
        <div class="panel-header">
          <b>{{ $t("visitor_log_detail_e_ticket.header") }}</b>
        </div>
        <div class="panel-body">
          <table class="table table-sm table-bordered w-100 mb-0">
            <thead>
                <tr>
                  <th>{{ $t("visitor_log_detail_e_ticket.subject") }}</th>
                  <th>{{ $t("visitor_log_detail_e_ticket.assigned_code") }}</th>
                  <th>{{ $t("visitor_log_detail_e_ticket.title") }}</th>
                  <th>{{ $t("visitor_log_detail_e_ticket.description") }}</th>
                </tr>
            </thead>

            <tbody>
                <tr v-for="x in e_tickets">
                  <td>{{ x.subject }}</td>
                  <td>{{ x.plan_codes.map(item => item.plan_code).join(', ') }}</td>
                  <td>{{ x.language_metadata[locale].title }}</td>
                  <td>{{ x.language_metadata[locale].content  }}</td>
                </tr>
            </tbody>
          </table>
        </div>
      </div>
    </template>
    <p v-else-if="showNotAvailable">
      {{ $t("visitor_log_detail_e_ticket.not_available") }}
    </p>
    <div v-else class="spinner-container">
      <i class="fa fa-spinner fa-spin reverse-spin "></i>
    </div>
  </div>
</template>

<style scoped>
td:first-child {
  min-width: 100px;
}
.qr-wrapper {
  border: 1px solid #dee2e6;
  float: left;
  margin-right: 5px;
  clear: both;
}
.spinner-container {
  display: flex;
  align-items: center;
  justify-content: center;
  height: 100px; /* Adjust as needed */
}
.fa-spinner {
  font-size: 2rem;
  margin-right: 10px;
}
.reverse-spin {
  animation: reverse-spin 1.5s infinite linear;
}

@keyframes reverse-spin {
  0% {
    transform: rotate(0deg);
  }
  100% {
    transform: rotate(-360deg);
  }
}
</style>

<script>
import _ from "lodash";
import moment from "moment";

export default {
  props: {
    visitorLog: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      e_tickets: [],
      isLoaded: false, // track digital key loading state
      isDataLoaded: false // track if data is successfully loaded
    };
  },
  computed: {
    locale() {
      return this.$i18n.locale;
    },

    isCheckoutPassed() {
      const date = this.visitorLog.booking_details.checkout_date;

      return moment(date).isBefore(moment(), "day");
    },

    showETickets() {
      return (
        this.isLoaded &&
        this.isDataLoaded &&
        this.e_tickets.length > 0 &&
        !this.isCheckoutPassed
      );
    },

    showNotAvailable() {
      return (
        this.isLoaded &&
        (
          this.e_tickets.length === 0 ||
          this.isCheckoutPassed
        )
      );
    } 
  },
  async created() {
    await this.loadData();
  },
  methods: {
    async loadData() { // wait for eticket endpoint to finish loading
      try {
        await this.fetchData();
      } catch (error) {
        console.error('Error fetching data:', error);
      } finally {
        this.isLoaded = true;
      }
    },
    async fetchData() {
      if(this.visitorLog.booking_details["pms_reservation_no"]) {
        const facility = window._app_facility;
        
        const response = await this.$lionheart.get(
          "/v2/my-page-coupons",
          {
            params: {
              pms_code: this.visitorLog.booking_details["pms_code"],
              pass: this.visitorLog.booking_details["pass"],
              pms_reservation_no:
                this.visitorLog.booking_details["pms_reservation_no"],
            },
          }
        );
        this.e_tickets = response.data.data;
        if (response.status === 200) {
          this.isDataLoaded = true;
        }
      }
    },
  },
};
</script>
